import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'

import { humanizePlan } from 'features/billing/helpers'

import { Paragraph } from './styles'

const ScheduledMessage = ({ quantity, date }) => {
  const messageHtml = HtmlParser(
    I18n.t('publisher.billing.change_plan.invoice_message.quantity_decrease.seat_count_html.scheduled', {
      count: quantity,
      date
    }))
  return (<div>{messageHtml}</div>)
}

const ImmediateMessage = ({ quantity }) => {
  const messageHtml = HtmlParser(
    I18n.t('publisher.billing.change_plan.invoice_message.quantity_decrease.seat_count_html.immediate', {
      count: quantity
    }))
  return (
    <>
      {messageHtml}
    &nbsp;
      {I18n.t('publisher.billing.change_plan.invoice_message.quantity_decrease.immediacy_warning')}
    </>
  )
}

export const DecreaseQuantityInvoiceMessage = ({ invoice, provider }) => (
  <div>
    <Paragraph>
      {provider === 'chargebee'
        && <ImmediateMessage quantity={invoice.new_quantity} />}
      {provider === 'stripe'
        && <ScheduledMessage quantity={invoice.new_quantity} date={invoice.next_payment_date} />}
    </Paragraph>
    <Paragraph>
      {HtmlParser(
        I18n.t('publisher.billing.change_plan.invoice_message.quantity_decrease.message_html', {
          amount: invoice.next_amount_due,
          plan: invoice.new_plan_id && humanizePlan(invoice.new_plan_id),
          date: invoice.next_payment_date
        })
      )}
    </Paragraph>
  </div>
)
